module.exports = __webpack_public_path__ + "static/img/3.a73a7fb5.png";